import ImageTooltip from "./ImageTooltip";
export default ImageTooltip;
